<div class="auth-page-wrapper">
  <div class="auth-form-container auth-form-side">
    <div class="auth-card" style="max-width:500px;width:100%">
      @if (verificationType === 'signup') {
        <div class="auth-steps">
          <div class="auth-step auth-step--done">
            <div class="auth-step__dot">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
            </div>
            <span class="auth-step__label">Account</span>
          </div>
          <div class="auth-step-connector auth-step-connector--done"></div>
          <div class="auth-step auth-step--active">
            <div class="auth-step__dot">2</div>
            <span class="auth-step__label">Verify</span>
          </div>
          <div class="auth-step-connector"></div>
          <div class="auth-step">
            <div class="auth-step__dot">3</div>
            <span class="auth-step__label">Done</span>
          </div>
        </div>
      }

        <div class="otp-header">
          <img src="assets/logo.png" alt="RAD" class="otp-logo"/>
          <div class="auth-icon-wrap auth-icon-wrap--blue" style="margin:0 auto 1rem">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
              <polyline points="22,6 12,13 2,6"/>
            </svg>
          </div>
          <h1 class="auth-heading" style="text-align:center">{{getPageTitle()}}</h1>
          <p class="auth-subheading" style="text-align:center">{{getVerificationMessage()}}</p>
          <div class="email-display">
            <mat-icon>email</mat-icon>
            <span>{{formatEmail(email)}}</span>
          </div>
        </div>

        <form [formGroup]="otpForm" (ngSubmit)="onSubmit()" class="otp-form">
          <div class="otp-input-section">
            <div class="auth-field">
              <input
                class="auth-input"
                formControlName="otp"
                type="text"
                maxlength="6"
                (input)="onOtpInput($event)"
                autocomplete="one-time-code"
                placeholder=" "
                style="text-align:center;letter-spacing:0.6em;font-size:1.5rem;font-weight:700;font-family:monospace">
              <label class="auth-field__label-top">Enter 6-digit code</label>
            </div>
          </div>

          <!-- Error Message -->
          @if (error) {
            <div class="error-message">
              <mat-icon>error</mat-icon>
              <span>{{error}}</span>
            </div>
          }

          <!-- Success Message -->
          @if (success) {
            <div class="success-message">
              <mat-icon>check_circle</mat-icon>
              <span>{{success}}</span>
            </div>
          }

          <!-- Submit Button -->
          <div class="form-actions">
            @if (loading) {
              <button
                type="submit"
                mat-raised-button
                color="primary"
                class="verify-button btn-primary btn-full btn-lg"
                disabled>
                <span class="btn-spinner"></span>
                Verifying...
              </button>
            } @else {
              <button
                type="submit"
                mat-raised-button
                color="primary"
                class="verify-button btn-primary btn-full btn-lg"
                [disabled]="otpForm.invalid">
                Verify Code
              </button>
            }
          </div>
        </form>

        <!-- Resend Section -->
        <div class="resend-section auth-resend">
          <p>Didn't receive the code?</p>
          @if (canResend) {
            <button
              mat-stroked-button
              (click)="resendOTP()"
              class="resend-button auth-resend__btn"
              [disabled]="loading">
              <mat-icon>refresh</mat-icon>
              Resend Code
            </button>
          } @else {
            <div class="countdown">
              <mat-icon>schedule</mat-icon>
              <span>Resend available in {{countdown}}s</span>
            </div>
          }
        </div>

        <!-- Footer -->
        <div class="otp-footer">
          <p class="auth-footer">Having trouble? <a routerLink="/login" class="help-link">Back to Login</a></p>
        </div>
    </div>
  </div>
  <div class="auth-image-container">
    <img src="assets/auth/loginImage.webp" alt="Verification Image">
  </div>
</div>
